/**
 * 客户工作平台模块接口列表
 */

import { base, baseGateway, base3Xway } from "./base"; // 导入接口域名列表
import axios from "@/utils/http"; // 导入http中创建的axios实例

const client = {
  //  头部获取登录人信息
  getPersonInfoMe() {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-baseinfo/queryUserInfo`
    );
  },
  //  头部获取企业信息
  getCurrentCompany() {
    // return axios.get(`${base()}/chem-work-web/current-company`);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/current-company`,
      {}
    );
  },
  // 获取企业自荐交易身份  企业简介页面
  postSelectCompanyBaseinfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/api/selectCompanyBaseinfo`,
      params
    );
  },

  // 我的订阅
  getSubscriptionAjaxLeafClass() {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/current-company-subscribe`,
      {}
    );
  },

  // 个人中心
  //  个人信息  初始化
  // getUserContextQuery(params) {
  //     return axios.get(`${base()}/uam-web/personInfo/userContext/query`, params);
  // },
  getUserPersonQuery(params) {
    return axios.get(`${base()}/uam-web/personInfo/userPerson/query`, params);
  },
  // 修改账号
  postPersonInfoAccount(params) {
    return axios.post(`${base()}/uam-web/personInfo/account`, params);
  },
  // 企业列表
  getCompanyListQuery(params) {
    return axios.get(
      `${base()}/uam-web/personInfo/companyList/query/${params}`
    );
  },
  // 个人中心编辑姓名
  postPersonInfoUserName(params) {
    return axios.post(`${base()}/uam-web/personInfo/userName`, params);
  },

  // 个人中心修改手机号
  postPersonInfoUpdateMobile(params) {
    return axios.post(`${base()}/uam-web/personInfo/update/mobile`, params);
  },
  // 验证手机号  验证手机号和验证码是否匹配
  postMassageMobileMsgCodeCheck(params) {
    return axios.post(`${base()}/uam-web/massage/mobile/msgCode/check`, params);
  },
  // 个人中心页面校验手机号是否存在 /${params}
  // getPersonInfoIsExist(params) {
  //     return axios.get(`${base()}/uam-web/personInfo/isExist/${params}`);
  // },
  // 发送短信验证码
  // postMassageSend(params) {
  //     return axios.post(`${base()}/uam-web/massage/send/${params}`, params);
  // },

  //  获取P代码关联的企业数量
  getPersonQueryCompanyCount(params) {
    return axios.get(`${base()}/uam-web/person/queryCompanyCount/${params}`);
  },

  // 个人注销输入密码获取手机号
  postPersonQueryMobile(params) {
    return axios.post(`${base()}/uam-web/person/queryMobile`, params);
  },

  // 注销个人账号
  postPersonCancel(params) {
    return axios.post(`${base()}/uam-web/person/cancel`, params);
  },

  // 个人中心修改密码
  postUpdatePasswordMobile(params) {
    return axios.post(
      `${base()}/uam-web/personInfo/update/password/mobile`,
      params
    );
  },

  // 个人中心修改授权委托书
  postModifyGrantWarrant(params) {
    return axios.post(
      `${base()}/uam-web/personInfo/modify/grantWarrant`,
      params
    );
  },

  // 企业信息文档---------------------------------------------------------
  // 企业工作台
  // 证书状态
  getChemicalsgetCertificateState(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/getCertificateState`,
      params
    );
  },
  // 头像上传
  postResumeSavePortrait(params) {
    return axios.post(`${base()}/srm-web/resume/savePortrait`, params, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  //附件查看下载
  getResumeAttachShow(params) {
    return axios.get(
      `${base()}/srm-api/resume/attach/show?attachUrl=${
        params.attachUrl
      }&type=${params.type}`
    );
  },
  //   //根据企业代码获取企业基本信息
  //   getQueryCompanyBaseInfoService(params) {
  //     return axios.get(
  //       `${base()}/srm-web/resume/queryCompanyBaseInfoService/${params}`
  //     );
  //   },
  //企业工商信息修改
  postCompanySaveService(params) {
    return axios.post(`${base()}/srm-web/resume/companySaveService`, params);
  },
  // 公司概况
  //根据企业代码获取企业概况基本信息
  getQueryCompanyEoBaseInfoService(params) {
    return axios.get(
      `${base()}/srm-web/resume/queryCompanyEoBaseInfoService/${params}`
    );
  },
  //根据企业代码查询企业基本信息-UAM
  getQueryCompanyByCode(orgId) {
    // return axios.get(
    //   `${base()}/uam-web/api/company/queryCompanyInfoByCode/${companyCode}`
    // );

    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/queryCompanyInfoByOrgId`,
      { orgId: orgId }
    );
  },
  //根据企业代码获取企业经营信息
  getQueryProductionInfoService(params) {
    return axios.get(
      `${base()}/srm-web/resume/queryProductionInfoService/${params}`
    );
  },
  //根据企业代码获取设备信息
  getQueryDeviceInfo(params) {
    return axios.get(`${base()}/srm-web/resume/queryDeviceInfo/${params}`);
  },
  //公司概况基本信息修改1
  postCompanyEoSaveService(params) {
    return axios.post(`${base()}/srm-web/resume/companyEoSaveService`, params);
  },
  //公司概况经营信息修改 2
  postSaveProductionInfo(params) {
    return axios.post(`${base()}/srm-web/resume/saveProductionInfo`, params);
  },
  //企业设备信息修改 3
  postSaveDeviceInfo(params) {
    return axios.post(`${base()}/srm-web/resume/saveDeviceInfo`, params);
  },
  //删除信息接口
  postResumeDelModel(params) {
    return axios.post(
      `${base()}/srm-web/resume/delModel?id=${params.id}&modelType=${
        params.modelType
      }`
    );
  },
  // 数字证书
  // 软正式列表查询
  postSearchApplication(params) {
    return axios.post(
      `${base()}/srm-web/application/searchApplication?srmMobile=${
        params.srmMobile
      }&status=${params.status}&srmEmail=${params.srmEmail}&pageSize=${
        params.pageSize
      }&pageIndex=${params.pageIndex}`
    );
  },
  // 选择合同章
  getChooseChop(params) {
    return axios.get(`${base()}/srm-web/application/chooseChop`, params);
  },
  // 校验邮箱是否可用
  postQueryEmailInfo(params) {
    return axios.post(`${base()}/srm-web/application/queryEmailInfo`, params);
  },
  // 新增软证书
  postSaveApplication(params) {
    return axios.post(`${base()}/srm-web/application/saveApplication`, params);
  },
  // 软证书编辑数据回显
  getQueryEmailInfo(params) {
    return axios.get(
      `${base()}/srm-web/application/toEditApplication/${params}`
    );
  },
  // 查询所有签证类型
  postCtmChopCtmChopList(params) {
    return axios.post(`${base()}/ctm-web/ctmChop/ctmChopList`, params);
  },
  // 新增合同章里的合同章上传   //新增合同章  // 编辑被驳回的合同章
  postCtmChopEditCtmChop(params) {
    return axios.post(`${base()}/ctm-web/ctmChop/editCtmChopKS`, params);
  },
  // 删除合同章
  postCtmChopDelCtmChop(params) {
    return axios.post(`${base()}/ctm-web/ctmChop/delCtmChop`, params);
  },
  // 编辑被驳回的合同章
  // postCtmChopEditCtmChop(params) {
  //     return axios.post(`${base()}/ctm-web/ctmChop/editCtmChop`, params);
  // },
  // 设置默认合同章
  postCtmChopLockCtmChop(params) {
    return axios.post(`${base()}/ctm-web/ctmChop/lockCtmChop`, params);
  },

  // 资质证书------------------------------------------------------------------
  // 资质证书新增
  postChemicalsSaveChemicals(params) {
    return axios.post(`${base()}/chem-lot-web/chemicals/saveChemicals`, params);
  },
  //资质证数新增-自荐注册专用
  postChemicalsSaveChemicalsKS(params) {
    return axios.post(
      `${base()}/chem-lot-web/chemicals/saveChemicalsKS`,
      params
    );
  },
  // 选择危化品类别
  getChemicalstoChemicalsList(params) {
    return axios.get(
      `${base()}/chem-lot-web/chemicals/toChemicalsList?page=${
        params.page
      }&rows=${params.rows}&chemicalsNo=${params.chemicalsNo}&chemicalsName=${
        params.chemicalsName
      }&chemicalsCas=${params.chemicalsCas}&contrastPorductname=${
        params.contrastPorductname
      }&chemicalsCategory=${params.chemicalsCategory}`
    );
  },
  // 文件上传OCR识别
  postChemicalsUploadChemicalsAttach(data, params) {
    return axios.post(
      `${base()}/chem-lot-web/chemicals/uploadChemicalsAttach?certificateType=${
        data.certificateType
      }&attachDesc=${data.attachDesc}`,
      params
    );
  },
  // 文件上传OCR识别-自荐注册专用
  postChemicalsUploadChemicalsAttachKS(companyCode, domainCode, params) {
    return axios.post(
      `${base()}/chem-lot-web/chemicals/uploadChemicalsAttachKS?companyCode=${companyCode}&domainCode=${domainCode}`,
      params
    );
  },
  // 资质证书列表查询
  getChemicalstoQualificationsList(params) {
    return axios.get(
      `${base()}/chem-lot-web/chemicals/toQualificationsList?page=${
        params.page
      }&rows=${params.rows}&companyName=${params.companyName}&certificateType=${
        params.certificateType
      }&certificateState=${params.certificateState}&type=${params.type}`
    );
  },
  // 资质证书列表查询-自荐注册专用
  getChemicalsgetQualificationsList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/query-company-qualifications`,
      params
    );
  },
  // 资质证书删除
  postChemicalsDeleteChemicals(params) {
    return axios.post(
      `${base()}/chem-lot-web/chemicals/deleteChemicals`,
      params
    );
  },
  // 资质证书编辑数据回显
  getChemicalsQueryChemicals(params) {
    return axios.get(
      `${base()}/chem-lot-web/chemicals/queryChemicals?certificateId=${
        params.certificateId
      }&type=${params.type}`
    );
  },
  // 资质证书修改以及审核
  postChemicalsUpdChemicals(params) {
    return axios.post(`${base()}/chem-lot-web/chemicals/updChemicals`, params);
  },
  //危化品列表查询
  getChemicalsQueryCategoryList(params) {
    return axios.get(`${base()}/chem-lot-web/chemicals/queryCategoryList`);
  },

  //证书二级分类列表
  getChemicalsSelectById(params) {
    return axios.get(`${base()}/chem-lot-web/chemicals/selectById/${params}`);
  },

  // 员工管理------------------------------------------------------------------
  // 列表查询
  postUserWorkList(params) {
    return axios.post(`${base()}/uam-web/user/work/list`, params);
  },
  // 解绑
  postUserWorkUnbind(params) {
    return axios.post(
      `${base()}/uam-web/user/work/unbind/${params.pCode}/${
        params.userLoginNo
      }`,
      params
    );
  },
  // 冻结
  postUserWorkFreeze(params) {
    return axios.post(
      `${base()}/uam-web/user/work/freeze/${params.userLoginNo}`,
      params
    );
  },
  // 激活
  postUserWorkThaw(params) {
    return axios.post(
      `${base()}/uam-web/user/work/thaw/${params.userLoginNo}`,
      params
    );
  },

  //获取手机号的用户信息
  getPersonInfoQuery(params) {
    return axios.get(`${base()}/uam-web/personInfo/query/${params}`);
  },
  //员工管理新增员工
  postUserWorkCreate(params) {
    return axios.post(`${base()}/uam-web/user/work/create`, params);
  },
  //管理员编辑员工
  postUserWorkEdit(params) {
    return axios.post(`${base()}/uam-web/user/work/edit`, params);
  },
  //管理员修改员工手机号
  postUserWorkModifyMobile(params) {
    return axios.post(`${base()}/uam-web/user/work/modify-mobile`, params);
  },
  //管理员重置员工密码
  postUserWorkResetPassword(params) {
    return axios.post(`${base()}/uam-web/user/work/reset-password/${params}`);
  },
  //加入企业申请审核
  postUserWorkApprove(params) {
    return axios.post(`${base()}/uam-web/user/work/approve`, params);
  },

  // 用户和权限
  // 角色管理
  //获取角色列表
  getChembusinessKsrole(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-role?systemRole=${
        params.systemRole
      }&roleName=${params.roleName}&page=${params.page}&size=${params.size}`
    );
  },
  //添加角色
  postChembusinessKsrole(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-role`,
      params
    );
  },
  //修改角色
  putChembusinessKsrole(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-role/up-role`,
      params
    );
  },
  //查询分配角色权限数据
  getChembusinessKsrolePermissionTreetransfer(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-role/${params}/permission/tree-transfer`
    );
  },
  //保存角色权限分配结果
  putChembusinessKsrolePermissions(roleId, params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-role/save-role/${roleId}/permissions`,
      params
    );
  },
  //查询角色用户列表
  getChembusinessKsroleRoleUsers(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-role/role-users?roleId=${
        params.roleId
      }&page=${params.page}&size=${params.size}`
    );
  },

  // 角色管理
  //获取角色列表
  getChembusinessKsuserRole(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-role?mobile=${
        params.mobile
      }&page=${params.page}&userCode=${params.userCode}&size=${
        params.size
      }&userName=${params.userName}`
    );
  },
  //查询用户角色列表
  getChembusinessKsuserRoleRoles(userId) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-role/roles/${userId}`
    );
  },
  //查询分配员工角色数据
  getChembusinessKsuserRoleTransfer(userId) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-role/${userId}/transfer`
    );
  },
  //修改用户角色
  putChembusinessKsuserRole(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-role/up-role`,
      params
    );
  },
  //查询角色权限树
  getChembusinessKsrolePermissionTree(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-role/${params}/permission/tree`
    );
  },
  //获取用户所有角色权限集合
  getChembusinessKsUserBaseinfoPermissionTree() {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-user-baseinfo/permission/tree`
    );
  },
  // 地址信息
  // 地址列表
  postAddressAddressList(params) {
    // return axios.get(`${base()}/srm-web/invoice/queryReceipt?companyCode=${params.companyCode}&pageIndex=${params.pageIndex}&pageSize=${params.pageSize}&invoiceType=${params.invoiceType}&issuer=${params.issuer}`);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/address/addressList`,
      params
    );
  },
  // 地址列表 未登录)
  postAddressSaveAddress(params) {
    // return axios.get(`${base()}/srm-web/invoice/queryReceiptNoLogin?companyCode=${params.companyCode}&pageIndex=${params.pageIndex}&pageSize=${params.pageSize}&invoiceType=${params.invoiceType}&issuer=${params.issuer}`);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/address/saveAddress`,
      params
    );
  },
  //地区列表
  postResumegetAreaList(params) {
    // return axios.post(`${base()}/srm-web/resume/getAreaList`, params);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/api/getAreaList`,
      params
    );
  },
  //新增/编辑地址
  postInvoiceSaveReceipt(params) {
    return axios.post(`${base()}/srm-web/invoice/saveReceipt`, params);
  },
  //新增/编辑地址（无需登录）
  postInvoiceSaveReceiptNoLogin(params) {
    return axios.post(`${base()}/srm-web/invoice/saveReceiptNoLogin`, params);
  },
  //删除地址
  postInvoiceRemoveReceipt(params) {
    return axios.post(`${base()}/srm-web/invoice/removeReceipt`, params);
  },
  //删除地址（无需登录）
  postInvoiceRemoveReceiptNoLogin(params) {
    return axios.post(`${base()}/srm-web/invoice/removeReceiptNoLogin`, params);
  },
  //合同
  postContract(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/pageCustomCtm?page=${
        params.page
      }&size=${params.size}`,
      params.tCustomContractDTO
    );
  },
  //客户工作台根据状态查合同数
  postContractStatus(corporateCode) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/pageCustomCount?corporateCode=${corporateCode}&flag=0`
    );
  },
  //客户工作台查询合同详情
  postContractDetaile(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/selectCustomContractDetail/${params}`
    );
  },
  // // 合同详情下载
  // clientList() {
  //     return axios.get(`${base()}/chem-ctm/contractTest/download`);
  // },

  //客户工作台合同签署
  getSharesContractWaterMarker2FddShow(params) {
    return axios.get(
      `${base()}/ctm-web/ctmContract/sharesContractWaterMarker2FddShow?contractId=${
        params.contractId
      }&createUser=${params.createUser}&isYoung=${params.isYoung}`
    );
  },

  // 客户...
  clientList() {
    return axios.get(`${base()}/demo`);
  },
  // 客户...详情
  clientDetail(id, params) {
    return axios.get(`${base()}/demo/${id}`, {
      params: params,
    });
  },

  // 客户...竞价交易 查询列表信息
  competitivePriceTransaction(params) {
    // return axios.post(`${base()}/chem-bdt-web/batch/page`, params);
    // return axios.post(`${base3Xway()}/i/batch/page`, params);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/batch/page`,
      params
    );
  },
  // 客户...竞价交易 根据物资id查询物资信息
  competitivePriceTransactionGetDetail(priceId) {
    return axios.post(
      `${base()}/chem-bdt-web/batchManager/showItemDetail?priceId=${priceId}`
    );
  },

  // 客户...挂牌交易 查询列表信息
  postResourcePage(params) {
    // return axios.post(`${base()}/chem-lot-web/resource/page`, params);
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/resource/page`,
      params
    );
  },
  // 客户...挂牌交易 购买信息
  postQueryLotResourcePreferentialById(params) {
    return axios.post(
      `${base()}/chem-portal-web/portal/queryLotResourcePreferentialById`,
      params
    );
  },

  // 菜单
  menuDetail(parentMenuId) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-business/ks-menu/${parentMenuId}`
    );
  },

  // 客户工作台 授信管理 资金授信
  //资金授信
  postFundCreditQueryCredit(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-pay/fundCredit/queryCredit`,
      params
    );
  },
  //交易记录
  postFundCreditQueryPaymentHistory(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-pay/fundCredit/queryPaymentHistory`,
      params
    );
  },

  // 客户工作台 需求管理 月度需求
  // 导入上月数据
  postLastMonthData() {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/demand/importLastMonthPlan`
    );
  },
  // 需求列表查询
  postNeedListSearch(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/demand/demandList`,
      params
    );
  },
  // 需求新增
  postAddNeed(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/demand/saveDemand`,
      params
    );
  },
  // 需求删除
  postDeleteNeed(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/demand/removeDemand?requireId=${
        params.requireId
      }`
    );
  },
  // 月度需求同步
  postSyncdDemand(params) {
    return axios.post(`${base()}/chem-ctm/demand/syncYdDemand`, params);
  },
  // 客户工作台 -- 报价单
  // 报价单查询
  postSearchPriceSheet(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/customerQuotation/page`,
      params
    );
  },
  // 报价单详情查询
  getPriceSheetDet(id) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/customerQuotation/info/${id}`
    );
  },
  // 报价单签署
  postSignPriceSheet(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/customerQuotation/sync`,
      params
    );
  },
};

export default client;
